/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const billingAdjustments = sqliteTable('billing_adjustments', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  patient_id: text('patient_id'),
  invoice_id: text('invoice_id'),
  encounter_id: text('encounter_id'),
  adjustment_type: text('adjustment_type'),
  amount_cents: integer('amount_cents'),
  reason: text('reason'),
  note: text('note'),
  adjusted_at: text('adjusted_at'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  created_by: text('created_by'),
  updated_by: text('updated_by'),
});
